import { combineReducers } from "redux";
import CommonReducer from "./CommonReducer";
import popup from "./popup";
import SystemSettingsReducer from "./SystemSettings";
import CommandsReducer from "./CommandsReducer";
import FlowData from "./FlowData";
const reducers = combineReducers({CommonReducer, popup, SystemSettingsReducer, CommandsReducer, FlowData});
export default reducers;